module.exports = __webpack_public_path__ + "static/media/img_27.0479c4b2.png";